import dayjs from 'dayjs';

type FormattedDateTime = {
    formattedTime: string;
    formattedDate: string;
};

export const getFormattedDateTime = (dateString: string | undefined): FormattedDateTime => {
    const defaultValues = { formattedTime: '', formattedDate: '-' };
    if (!dateString) return defaultValues;

    const datetime = new Date(dateString);
    if (isNaN(datetime.getTime())) return defaultValues;

    const dateFormat = import.meta.env.VITE_DATE_FORMAT || 'DD.MM.YYYY';
    const timeFormat = import.meta.env.VITE_TIME_FORMAT || 'HH:mm:ss';

    const formattedDate = dayjs(dateString).format(dateFormat);

    const formattedTime = dayjs(dateString).format(timeFormat);

    if (formattedTime === 'Invalid Date' || formattedDate === 'Invalid Date') return defaultValues;

    return {
        formattedTime,
        formattedDate,
    };
};

// Function for getting the formatted datetime used in details panels
export const getFormattedDateTimeForDetailPanel = (dateString: string | undefined): string => {
    const { formattedTime, formattedDate } = getFormattedDateTime(dateString);
    return formattedTime && formattedDate ? `${formattedDate} ${formattedTime}` : '-';
};
